module.exports = __webpack_public_path__ + "img/compass.45766009.svg";